function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "C946BB96-F517-486A-B36D-18C399656952");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ATF_V2-3_1200px",
  transform: "translate(-918.000000, -463.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(898.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(18.000000, 342.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.6933354,21.3600878 C17.8817974,19.573557 16.4875959,6.61462572 12.176048,6.61462572 C7.86450002,6.61462572 4.5591752,8.27803269 4.5591752,11.4137039 C4.5591752,14.5493752 7.50487347,23.1466185 12.6933354,21.3600878 Z",
  id: "Path-2-Copy-2",
  fill: "#E8C230",
  transform: "translate(10.295987, 14.108239) scale(-1, 1) rotate(-71.000000) translate(-10.295987, -14.108239) "
}), /*#__PURE__*/React.createElement("g", {
  id: "outline-location_on-24px"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 17.0322581 0 17.0322581 17.0322581 0 17.0322581"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.51612903,1.41935484 C5.76967742,1.41935484 3.5483871,3.64064516 3.5483871,6.38709677 C3.5483871,10.1129032 8.51612903,15.6129032 8.51612903,15.6129032 C8.51612903,15.6129032 13.483871,10.1129032 13.483871,6.38709677 C13.483871,3.64064516 11.2625806,1.41935484 8.51612903,1.41935484 Z M4.96774194,6.38709677 C4.96774194,4.4283871 6.55741935,2.83870968 8.51612903,2.83870968 C10.4748387,2.83870968 12.0645161,4.4283871 12.0645161,6.38709677 C12.0645161,8.43096774 10.0206452,11.4896774 8.51612903,13.3987097 C7.04,11.503871 4.96774194,8.40967742 4.96774194,6.38709677 Z",
  id: "Shape",
  fill: "#220C89",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#220C89",
  fillRule: "nonzero",
  cx: 8.51612903,
  cy: 6.38709677,
  r: 1.77419355
})))))));

var SvgGroup2 = function SvgGroup2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group2.250d852e.svg";
export { ForwardRef as ReactComponent };